$(document).ready(() => {


    const megaContainer = $('.mega-menu-container');
    let containerHeight = 0;
    let containerPadding = 32;

    function calculateHeightOfChildren(menu)
    {
        return menu.find(' > li').toArray().reduce((total, el) => total + el.clientHeight, 0);
    }


    $('.navigation-container .has-dropdown').each(function () {
        $(this).hover(function () {
            const levelTwoMenu = $(this).find('.level-two-menu');
            const levelTwoMenuContainer = $(this).find('.level-two-menu-container');
            let levelTwoMenuHeight = levelTwoMenu.length ? calculateHeightOfChildren(levelTwoMenu) : 0;

            $(this).find('.category-aside').css({ visibility: 'hidden', opacity: '0' });
            $(this).siblings().find('.category-aside').css({ visibility: 'hidden', opacity: '0' });

            levelTwoMenu.find('> li').hover(function () {
                const levelTwoCategoryAside = $(this).find('.category-aside');
                const levelTwoCategoryAsideHeight = levelTwoCategoryAside.length ? levelTwoCategoryAside[0].offsetHeight : 0;
                let levelTwoContainerHeight = 0;

                // Hide the other dropdowns
                $(this).siblings().find('.level-three-menu-container').css({ visibility: 'hidden', opacity: '0' });

                $(this).siblings().find('.level-three-item-container').removeClass('hover')
                $(this).siblings().find('.level-four-item-container').removeClass('hover')


                $(this).siblings().find('.level-two-item-container').removeClass('hover');
                $(this).find('.level-two-item-container').addClass('hover')


                if (levelTwoCategoryAside.length) {
                    levelTwoCategoryAside.css({ visibility: 'visible', opacity: '1' });
                }

                if ($(this).hasClass('has-sub-dropdown')) {
                    const levelThreeMenu = $(this).find('.level-three-menu');
                    const levelThreeMenuContainer = $(this).find('.level-three-menu-container');
                    const levelThreeItemContainer = $(this).find('.level-three-item-container');
                    const levelThreeMenuHeight = calculateHeightOfChildren(levelThreeMenu);

                    levelThreeMenuContainer.css({ visibility: 'visible', opacity: '1' });
                    // levelThreeMenuContainer.siblings().find('.level-three-menu-container').css({ visibility: 'hidden', opacity: '0' });

                    levelTwoContainerHeight = Math.max(levelTwoMenuHeight, levelThreeMenuHeight);

                    levelThreeMenu.find('> li').hover(function () {

                        $(this).siblings().find('.level-three-item-container').removeClass('hover');
                        $(this).siblings().find('.level-four-item-container').removeClass('hover');
                        $(this).find('.level-three-item-container').addClass('hover')

                        const levelFourMenuContainer = $(this).find('.level-four-menu-container');
                        let levelFourMenuContainerHeight = 0;

                        if ($(this).hasClass('has-sub-dropdown')) {
                            const levelFourMenu = $(this).find('.level-four-menu');
                            const levelFourMenuHeight = calculateHeightOfChildren(levelFourMenu);

                            levelFourMenuContainer.css({ visibility: 'visible', opacity: '1' });
                            levelFourMenuContainerHeight = Math.max(levelThreeMenuHeight, levelFourMenuHeight);

                            levelFourMenu.find('> li').hover(function () {

                                $(this).siblings().find('.level-four-item-container').removeClass('hover');
                                $(this).find('.level-four-item-container').addClass('hover')
                            });
                        }

                        $(this).siblings().find('.level-four-menu-container').css({ visibility: 'hidden', opacity: '0' });


                        // Factor in if level two height is greater than level four height
                        levelFourMenuContainerHeight = Math.max(levelFourMenuContainerHeight, levelTwoCategoryAsideHeight);

                        // Factor in if level three height is greater than level four height
                        levelFourMenuContainerHeight = Math.max(levelFourMenuContainerHeight, levelThreeMenuHeight);

                        const containerHeight = 60 + levelFourMenuContainerHeight + containerPadding * 2;

                        levelTwoMenu.css('height', `${containerHeight}px`);
                        levelThreeMenu.css('height', `${containerHeight}px`);
                        megaContainer.css('height', `${containerHeight}px`);

                    }, function () {
                        // $(this).find('.level-four-menu-container').css({ visibility: 'hidden', opacity: '0' });
                    });

                } else {
                    levelTwoContainerHeight = levelTwoMenuHeight;
                }

                levelTwoContainerHeight = Math.max(levelTwoContainerHeight, levelTwoCategoryAsideHeight);
                const containerHeight = 60 + levelTwoContainerHeight + containerPadding * 2;

                levelTwoMenu.css('height', `${containerHeight}px`);
                megaContainer.css('height', `${containerHeight}px`);

                $(this).siblings().find('.category-aside').css({ visibility: 'hidden', opacity: '0' });
                $(this).attr('aria-expanded', 'true').attr('aria-hidden', 'false');
            }, function () {
                // $(this).find('.level-three-menu-container').css({ visibility: 'hidden', opacity: '0' });
                // $(this).attr('aria-expanded', 'false').attr('aria-hidden', 'true');
            });

            const containerHeight = 60 + levelTwoMenuHeight + containerPadding * 2;
            megaContainer.css('height', `${containerHeight}px`);
            levelTwoMenuContainer.css({ visibility: 'visible', opacity: '1' });

            $(this).attr('aria-expanded', 'true').attr('aria-hidden', 'false');

        }, function () {
            $('.level-two-menu-container, .level-three-menu-container, .level-four-menu-container', this).css('visibility', 'hidden');
            $('.level-two-item-container, .level-three-item-container, .level-four-item-container', this).removeClass('hover');
            megaContainer.css('height', '60px');
            $(this).attr('aria-expanded', 'false').attr('aria-hidden', 'true');
        });
    });

// Shows the primary menu overlay
  $('.mobile-navigation-wrapper').find('.mobile-menu-toggle').click(function () {
    // Allow the body to scroll again.
    $('body').toggleClass('overflow-hidden');

    $('.primary-mobile-menu-overlay').toggleClass('hidden');
  });

  // Shows the contact menu overlay
  $('.mobile-navigation-wrapper').find('.contact-menu-toggle').click(function () {
    // Allow the body to scroll again.
    $('body').toggleClass('overflow-hidden');

    $('.mobile-contact-menu-overlay').toggleClass('hidden');
    $('.primary-mobile-menu-overlay').toggleClass('hidden');
  });

  // Hides the primary menu overlay
  $('.primary-mobile-menu-overlay-header').find('.mobile-menu-toggle').click(function () {
    // Make sure the body is not scrollable.
    $('body').removeClass('overflow-hidden');

    $('.primary-mobile-menu-overlay').addClass('hidden');
  });

  // Hides the contact menu overlay
  $('.mobile-contact-menu-overlay-header').find('.mobile-menu-toggle').click(function () {
    // Make sure the body is not scrollable.
    $('body').removeClass('overflow-hidden');

    // Add the hidden class if contact overlay is showing
    if (!$('.mobile-contact-menu-overlay').hasClass('hidden')) {
        $('.mobile-contact-menu-overlay').addClass('hidden');
    }
  });

  // Language Switcher
  // Hides the contact menu overlay
  $('#language-switcher').find('#language-menu-toggle').not('#language-dropdown a').click(function (e) {
    e.preventDefault();
    $('#language-dropdown').toggleClass('hidden');
  });

  // Setup the jQuery drilldown menu plugin.
  $('.drilldown').drilldown({ speed: 300 });

});
